import Orchestreur from "../../Orchestreur"
import ActeFourModels from "./models/ActeFourModels"
import CameraFour from "./props/camera"
import { Environment } from "@react-three/drei"
import { useIsMobile } from "../../utils/useIsMobile"



export default function ActeFour({ progress }) {

    const isMobile = useIsMobile()

    const Nnv = () => (
        <Environment files="img/potsdamer_platz_1k.hdr" />
    )


    const near = isMobile ? 27 : 16
    const far =isMobile ? 39 : 34
   
    // const color = "#ebddfc"
    const color = "#ddf8fc"
    // const color = "#c7e9ff"

    return (
        <>
            <Orchestreur
                id={3}
                progress={progress}
                range={{ start: 0.95, end: 1 }}
                Env={Nnv}
                Camera={CameraFour}
                Models={ActeFourModels}
                fog={{ color, near, far }}
            />

        </>
    )
}